// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.access-code-login {
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  padding: 24px;
}

.login-container {
  padding: 24px;
  max-width: 800px;
  margin: 0 auto;
  min-height: 100vh;
}

.login-card {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: none;
}

.login-content {
  padding: 32px;
}

.logo-section {
  text-align: center;
  margin-bottom: 32px;
}

.logo-section svg {
  height: 48px;
  width: auto;
}

.login-title {
  margin: 16px 0 8px 0 !important;
  color: #1a1a1a;
}

.login-subtitle {
  font-size: 14px;
  display: block;
}

.login-form {
  margin-top: 24px;
}

.login-form .ant-form-item-label > label {
  font-weight: 600;
}

.login-form .ant-input-affix-wrapper {
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  letter-spacing: 1px;
}

.login-form .ant-input-affix-wrapper:hover {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

.login-form .ant-input-affix-wrapper-focused {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15);
}

.login-form .ant-input {
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  letter-spacing: 1px;
  font-weight: 500;
}

.login-form .ant-input::placeholder {
  color: #bbb;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  letter-spacing: 0.5px;
}

.login-form .ant-input-prefix {
  margin-right: 12px;
}

.grant-access-button {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 16px;
}

.error-alert {
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/AccessCodeLogin.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yEAAyE;EACzE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yEAAyE;EACzE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yEAAyE;EACzE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".access-code-login {\n  min-height: 100vh;\n  background-image: url('/public/background.webp');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  padding: 24px;\n}\n\n.login-container {\n  padding: 24px;\n  max-width: 800px;\n  margin: 0 auto;\n  min-height: 100vh;\n}\n\n.login-card {\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: none;\n}\n\n.login-content {\n  padding: 32px;\n}\n\n.logo-section {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.logo-section svg {\n  height: 48px;\n  width: auto;\n}\n\n.login-title {\n  margin: 16px 0 8px 0 !important;\n  color: #1a1a1a;\n}\n\n.login-subtitle {\n  font-size: 14px;\n  display: block;\n}\n\n.login-form {\n  margin-top: 24px;\n}\n\n.login-form .ant-form-item-label > label {\n  font-weight: 600;\n}\n\n.login-form .ant-input-affix-wrapper {\n  border-radius: 8px;\n  border: 2px solid #e0e0e0;\n  transition: all 0.3s ease;\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  letter-spacing: 1px;\n}\n\n.login-form .ant-input-affix-wrapper:hover {\n  border-color: #1890ff;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);\n}\n\n.login-form .ant-input-affix-wrapper-focused {\n  border-color: #1890ff;\n  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15);\n}\n\n.login-form .ant-input {\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  letter-spacing: 1px;\n  font-weight: 500;\n}\n\n.login-form .ant-input::placeholder {\n  color: #bbb;\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  letter-spacing: 0.5px;\n}\n\n.login-form .ant-input-prefix {\n  margin-right: 12px;\n}\n\n.grant-access-button {\n  height: 50px;\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 16px;\n}\n\n.error-alert {\n  margin-top: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
